<template>
  <div>
    <b-row>
      <b-col cols="6"></b-col>
      <b-col cols="6">
        <div class="pull-right tools">
          <b-button size="sm" variant="primary" @click="$refs['view-fast-report'].showModal()">
            Print
          </b-button>
          <b-button size="sm" variant="primary" @click="openModal">
            <i class="fa fa-plus mr-1" aria-hidden="true"></i>Add Consignment
          </b-button>
        </div>
      </b-col>
    </b-row>
    <grid-component
      isResizable
      isReorderable
      isSortable
      :gridId="gridId"
      :itemData="itemData"
      :fields="fields"
      :pageable="pageable"
      :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
      :take="pageInfo.pageSize"
      :pageSizes="pageInfo.pageSize"
      :totalItems="pageInfo.totalItems"
      :sortBy="pageInfo.sortBy"
      :sortOrder="pageInfo.sortOrder"
      :sortMethod="sortGrid"
      :onEdit="onEdit"
      :onDelete="onDelete"
      :handleRowClick="onRowClick"
      :styleCustom="'height: 210px'"
      @getData="onGetData"
    />
    <add-consignment :partDetails="{}" :editDetails="selectedRowData" @redreshGrid="getGridList" :companyInfo="companyData" />
    <fast-report-viewer :parameter="companyId" :moduleName="'Consignments'" />
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex';
  import { GRID_ID, GRID_PAGE_SIZES } from '@/shared/constants';
  import GridSettings from '@/shared/components/GridSettings';
  import GridComponent from '@/shared/components/GridComponent';
  import gridFields from './fields';
  import AddConsignment from '@/shared/components/Consignments/components/Add';
  import FastReportViewer from '@/shared/components/FastReportViewer';

  export default {
    name: 'ConsignmentsTab',
    components: {
      GridSettings,
      GridComponent,
      AddConsignment,
      FastReportViewer
    },
    props: {
      partId: [Number, String],
      companyId: [Number, String],
      companyInfo: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        fields: gridFields,
        gridId: GRID_ID.CONSIGNMENTS_LIST,
        selectedRowItemId: 0,
        selectedRowData: {},
        companyData: {},
        pageable: {
          pageSizes: GRID_PAGE_SIZES
        }
      };
    },
    computed: {
      ...mapGetters('consignments', [
        'gridList',
        'pageInfo',
        'filters',
        'lastOpenedId',
      ]),
      ...mapGetters('account', ['gridSettingsById']),
      gridSettings() {
        return this.gridSettingsById(this.gridId);
      },
      itemData() {
        return this.gridList.map((item) => ({ ...item, selected: item.id === this.selectedRowItemId }));
      },
    },
    methods: {
      ...mapMutations('consignments', ['setItem']),
      ...mapActions('consignments', ['getAll', 'sortGrid', 'search', 'deleteRecord']),
      onRowClick(row) {
        this.selectedRowItemId = row.dataItem.id;
        this.selectedRowData = row.dataItem;
      },
      onEdit(row) {
        this.setItem({ resource: 'lastOpenedId', payload: row.id });
        this.selectedRowData = row;
        this.companyData = {};
        //console.log('onEdit',this.companyData);
        this.$bvModal.show('add-consignment-modal')
      },
      async onDelete(rma) {
        const deleteConfirmed = await this.openConfirmBox({});
        if (deleteConfirmed) {
          await this.deleteRecord(rma.id);
          this.getGridList();
        }
      },
      getGridList() {
        this.search(this.filters);
      },
      openModal(){
        this.selectedRowData = {};
        this.companyData = Object.assign({},this.companyInfo);
        //console.log('openModal',this.companyData);
        this.$bvModal.show('add-consignment-modal')
      },
      async onGetData(params) {
        await this.getAll(params)
      }
    },
    watch: {
      // async gridList() {
      //   //This function sets the first row as the selected row
      //   this.selectedRowItemId = await this.setSelectedRowId(this.gridList, this.selectedRowItemId, this.lastOpenedId);
      // },
      partId(newPartId) {
        // this.filters.partId = newPartId;
        this.setItem({ resource: 'filters', payload: { ...this.filters, partId: newPartId } });
        // this.getGridList();
      },
      companyId(newCompanyId) {
        // this.filters.companyId = newCompanyId;
        this.setItem({ resource: 'filters', payload: { ...this.filters, companyId: newCompanyId } });
        // this.getGridList();
      },
      filters() {
        this.getAll({});
      }
    },
    async mounted() {
      // this.filters.partId = this.partId;
      // this.filters.companyId = this.companyId;
      this.setItem({
        resource: 'filters',
        payload: { partId: this.partId, companyId: this.companyId }
      });
      this.setItem({
        resource: 'pageInfo',
        payload: { ...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize },
      });
      // this.getGridList();
    },
  };
</script>
